<template>
  <header
    class="fixed top-0 left-0 right-0 h-12 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 z-30 flex items-center px-4"
  >
    <div class="flex items-center justify-between w-full">
      <!-- Left side: Burger menu + Logo -->
      <div class="flex items-center gap-3">
        <button
          v-if="showSidebar"
          class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-gray-600 dark:text-gray-300"
          aria-label="Toggle sidebar"
          @click="$emit('toggle-sidebar')"
        >
          <i class="pi pi-bars text-xl"></i>
        </button>

        <router-link :to="helperHomePath" class="flex items-center">
          <img :src="logoSrc" alt="Jukebox Logo" class="h-8 w-auto" />
        </router-link>
      </div>

      <!-- Right side: Theme toggle -->
      <div class="flex items-center gap-2">
        <button
          class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-gray-600 dark:text-gray-300"
          aria-label="Toggle theme"
          :title="themeStore.isDark ? 'Switch to light mode' : 'Switch to dark mode'"
          @click="themeStore.toggleTheme"
        >
          <i v-if="themeStore.isDark" class="pi pi-sun text-xl"></i>
          <i v-else class="pi pi-moon text-xl"></i>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { computed } from "vue";
import { useAuthStore } from "../../stores/auth";
import { useThemeStore } from "../../stores/theme";
import { useLiveEvents } from "../../composables/useLiveEvents";
import { getHelperLivePath } from "../../utils/eventStatus";
import logoLight from "@/assets/images/jukesoft-logo.png";
import logoDark from "@/assets/images/jukesoft-logo--dark.png";

export default {
  name: "AppTopbar",
  props: {
    showSidebar: {
      type: Boolean,
      default: true
    }
  },
  emits: ["toggle-sidebar"],
  setup() {
    const authStore = useAuthStore();
    const themeStore = useThemeStore();
    const { liveEvents } = useLiveEvents();

    const logoSrc = computed(() => {
      return themeStore.isDark ? logoDark : logoLight;
    });

    const helperHomePath = computed(() => {
      if (!authStore.isHelper) return "/";
      return getHelperLivePath(liveEvents.value);
    });

    return {
      authStore,
      themeStore,
      logoSrc,
      helperHomePath
    };
  }
};
</script>
